// Get Expenses List
export const GET_EXPENSES_REQUEST = "GET_EXPENSES_REQUEST";
export const GET_EXPENSES_SUCCESS = "GET_EXPENSES_SUCCESS";
export const GET_EXPENSES_ERROR = "GET_EXPENSES_ERROR";

// Get Single Expense
export const GET_EXPENSE_REQUEST = "GET_EXPENSE_REQUEST";
export const GET_EXPENSE_SUCCESS = "GET_EXPENSE_SUCCESS";
export const GET_EXPENSE_ERROR = "GET_EXPENSE_ERROR";

// Create Expense
export const CREATE_EXPENSE_REQUEST = "CREATE_EXPENSE_REQUEST";
export const CREATE_EXPENSE_SUCCESS = "CREATE_EXPENSE_SUCCESS";
export const CREATE_EXPENSE_ERROR = "CREATE_EXPENSE_ERROR";

// Update Expense
export const UPDATE_EXPENSE_REQUEST = "UPDATE_EXPENSE_REQUEST";
export const UPDATE_EXPENSE_SUCCESS = "UPDATE_EXPENSE_SUCCESS";
export const UPDATE_EXPENSE_ERROR = "UPDATE_EXPENSE_ERROR";

// Delete Expense
export const DELETE_EXPENSE_REQUEST = "DELETE_EXPENSE_REQUEST";
export const DELETE_EXPENSE_SUCCESS = "DELETE_EXPENSE_SUCCESS";
export const DELETE_EXPENSE_ERROR = "DELETE_EXPENSE_ERROR";

// Get Summary
export const GET_EXPENSE_SUMMARY_REQUEST = "GET_EXPENSE_SUMMARY_REQUEST";
export const GET_EXPENSE_SUMMARY_SUCCESS = "GET_EXPENSE_SUMMARY_SUCCESS";
export const GET_EXPENSE_SUMMARY_ERROR = "GET_EXPENSE_SUMMARY_ERROR";

// Get Expenses by Reason
export const GET_EXPENSES_BY_REASON_REQUEST = "GET_EXPENSES_BY_REASON_REQUEST";
export const GET_EXPENSES_BY_REASON_SUCCESS = "GET_EXPENSES_BY_REASON_SUCCESS";
export const GET_EXPENSES_BY_REASON_ERROR = "GET_EXPENSES_BY_REASON_ERROR";

// Clear Actions
export const CLEAR_EXPENSE_ERRORS = "CLEAR_EXPENSE_ERRORS";
export const CLEAR_EXPENSE_VALIDATION_ERRORS = "CLEAR_EXPENSE_VALIDATION_ERRORS";
